import { useState } from "react"

import TWInput from "../components/utils/TWInput/TWInput"
import TWButton from "../components/utils/TWButton/TWButton"
import AuthLayout from "../layouts/AuthLayout/AuthLayout"
import { useHistory } from "react-router-dom"

const SignIn = () => {
	const history = useHistory()
	const [user, setUser] = useState({
		email: '',
		password: ''
	})

	return (
		<AuthLayout>
			<div className="login">
				<form>
					<TWInput
						dark
						name="email"
						label="Email"
						type="email"
						className="mb-1 md:mb-6"
						value={user.email}
						hint="johnnybravo@gmail.com"
						inputClass="w-full md:w-96"
						labelClass='flex-1 text-right'
						onChange={email => setUser({ ...user, email })}
					/>
					<TWInput
						dark
						hint="***********"
						name="password"
						label="Password"
						type="password"
						className="mb-1 md:mb-6"
						inputClass="w-full md:w-96"
						value={user.password}
						labelClass='flex-1 text-right'
						onChange={password => setUser({ ...user, password })}
					/>
					<TWButton
						size="sm"
						color="primary"
						className="px-10 mt-3 lg:mt-0 block ml-auto"
						// disabled="invalid"
						onClick={() => history.push('/home')}
					>
						Login
					</TWButton>
				</form>
			</div>
		</AuthLayout>
	)
}

export default SignIn